// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3I8pE","disabled":"FileBtn_disabled__2AtkK","warn":"FileBtn_warn__3OVcL","fade":"FileBtn_fade__19PV7"};